import { Controller } from "stimulus";

export default class ExpandableController extends Controller {
  toggleExpanded() {
    this.element.classList.toggle("expanded");
  }
}
